import { EmptyError, firstValueFrom, Observable } from 'rxjs';

export async function toPromise<T>(source$: Observable<T>): Promise<T> {
  try {
    return await firstValueFrom(source$);
  } catch (error) {
    return await (error instanceof EmptyError ? Promise.resolve(undefined as T) : Promise.reject(error));
  }
}
